export default "__VITE_ASSET__f6505771__"